import { interpUri } from '@b-stock/fe-core/bstock-react'
import type { StoreFrontDto } from '@b-stock/listing-api-client'

export function getStorefrontUrlFromSlug(slug: string) {
  return interpUri`/buy/seller/${slug}`
}

export default function getStorefrontUrl(
  storefront: StoreFrontDto | null | undefined
) {
  // A hidden storefront has no buyer-facing page to link to.
  if (!storefront?.slug || storefront.options?.isHidden) {
    return null
  }
  return getStorefrontUrlFromSlug(storefront.slug)
}
